import angular from 'angular'

/**
 * Teeny little directive to print '*** Open Cash Drawer ***' to pop the cash drawer.
 *
 * @module webregister.directives.wrPrintOpenDrawer
 */
angular
  .module('webregister.directives')
  .directive('wrPrintOpenDrawer', function () {
    return {
      template: '<p class="vd-show-print">**** Open Cash Drawer ****</p>',
      controller() {},
    }
  })
